var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98443 32H25.0094C27.9095 32 30.1254 30.8819 31.2557 28.8819C32.386 26.8504 32.2224 24.2677 30.8095 21.5748L21.797 4.3937C20.3098 1.55906 18.2575 0 15.9969 0C13.7364 0 11.684 1.55906 10.1968 4.3937L1.1843 21.5591C-0.228549 24.252 -0.37727 26.8504 0.738138 28.8661C1.86842 30.8819 4.08436 32 6.98443 32ZM12.145 5.54331C13.2307 3.49606 14.5989 2.3622 15.9969 2.3622C17.3949 2.3622 18.7631 3.49606 19.8488 5.54331L28.8762 22.7244C29.8875 24.6614 30.0659 26.4094 29.3521 27.685C28.6382 28.9606 27.1064 29.6535 25.0243 29.6535H6.9993C4.9172 29.6535 3.3705 28.9606 2.67151 27.685C1.97252 26.4094 2.13612 24.6457 3.14742 22.7244L12.145 5.54331ZM16 20.125C15.385 20.125 14.875 19.615 14.875 19V11.5C14.875 10.885 15.385 10.375 16 10.375C16.615 10.375 17.125 10.885 17.125 11.5V19C17.125 19.615 16.615 20.125 16 20.125ZM16 24.9998C15.91 24.9998 15.805 24.9848 15.7 24.9698L15.7 24.9698C15.5124 24.9386 15.3338 24.8578 15.1743 24.7542C15.1695 24.7512 15.1648 24.748 15.16 24.7448L14.935 24.5648C14.665 24.2798 14.5 23.8898 14.5 23.4998C14.5 23.1098 14.665 22.7198 14.935 22.4348L15.16 22.2548C15.1648 22.2517 15.1695 22.2485 15.1743 22.2454C15.3338 22.1419 15.5124 22.0611 15.7 22.0298C15.895 21.9848 16.105 21.9848 16.285 22.0298C16.4829 22.0581 16.6737 22.144 16.84 22.2548L17.065 22.4348C17.335 22.7198 17.5 23.1098 17.5 23.4998C17.5 23.8898 17.335 24.2798 17.065 24.5648L16.84 24.7448C16.6737 24.8557 16.4829 24.9416 16.285 24.9698C16.195 24.9848 16.09 24.9998 16 24.9998Z",
    fill: "url(#paint0_linear_3200_15823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3200_15823",
    x1: -5.33333,
    y1: -2.6491e-7,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706855,
    stopColor: "#185B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.745e71a049c4f91e14bd75a6989de693.svg";
export { ForwardRef as ReactComponent };